import { useState } from "react";
import { Heart, X } from "lucide-react";
import { toast } from "sonner";

// Donation destinations. PayPal activates automatically once PAYPAL_URL is set.
export const CASHAPP_URL = "https://cash.app/$DennisHaymon8";
export const PAYPAL_URL = ""; // add your PayPal.me link here, e.g. https://paypal.me/yourname

export default function DonateModal({ variant = "solid", className = "", testid = "donate-btn" }) {
  const [open, setOpen] = useState(false);

  const base =
    "flex items-center gap-2 rounded-full px-5 py-2 font-cond font-bold uppercase tracking-wide text-sm transition-colors";
  const styles = {
    solid: "bg-[#FF6B00] hover:bg-[#FF8526] text-[#050B14] amber-glow",
    outline: "border border-[#FF6B00] text-[#FF6B00] hover:bg-[#FF6B00] hover:text-[#050B14]",
    dark: "bg-[#050B14] hover:bg-[#0C1424] text-white",
  };

  const openPaypal = () => {
    if (PAYPAL_URL) {
      window.open(PAYPAL_URL, "_blank", "noopener");
    } else {
      toast.info("PayPal is coming soon — CashApp is ready now!");
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid={testid}
        className={`${base} ${styles[variant]} ${className}`}
      >
        <Heart className="h-4 w-4 fill-current" /> Donate
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[80] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
          data-testid="donate-modal"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md rounded-2xl border border-[#FF6B00]/30 bg-[#0C1424] p-8 text-center"
          >
            <button
              onClick={() => setOpen(false)}
              data-testid="donate-modal-close"
              className="absolute top-4 right-4 text-[#94A3B8] hover:text-[#FF6B00]"
            >
              <X className="h-6 w-6" />
            </button>

            <div className="flex justify-center mb-4">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#FF6B00]/15 border border-[#FF6B00]/40">
                <Heart className="h-7 w-7 text-[#FF6B00] fill-[#FF6B00]" />
              </span>
            </div>
            <h3 className="font-display text-3xl uppercase leading-none">Support The Show</h3>
            <p className="mt-3 text-sm text-[#94A3B8]">
              Your donation keeps the conversation going — real stories, real people, real change in St. Louis.
            </p>

            <div className="mt-7 space-y-3">
              <a
                href={CASHAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="donate-cashapp-link"
                className="flex items-center justify-center gap-2 rounded-lg bg-[#00D632] hover:bg-[#00c02d] transition-colors px-5 py-3.5 font-cond font-bold uppercase tracking-wide text-[#04210b]"
              >
                <span className="font-display text-lg">$</span> Donate with CashApp
              </a>
              <div className="font-mono2 text-xs text-[#94A3B8]">$DennisHaymon8</div>

              <button
                onClick={openPaypal}
                data-testid="donate-paypal-link"
                className="w-full flex items-center justify-center gap-2 rounded-lg bg-[#0070BA] hover:bg-[#005ea6] transition-colors px-5 py-3.5 font-cond font-bold uppercase tracking-wide text-white"
              >
                Donate with PayPal
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
